<template>
  <div>
    <div class="header" v-if="!mobile">
      <el-row :gutter="10">
        <el-col :span="8" :xs="4">
          <div class="logo">
            <img src="@/assets/img/function/logo.png" alt=""  @click="jumpNavigation(0)">
          </div>
        </el-col>
        <el-col :span="2" :lg="3" :md="4" :sm="3" :xs="4" >
         <div @click="jumpNavigation(1)">
            {{ $t("寺院簡介") }}
          </div>    
        </el-col>
        <el-col :span="2" :lg="3" :md="4" :sm="3" :xs="4" @click="jumpNavigation(2)"
          >
          <div @click="jumpNavigation(2)">{{ $t("妙智莊嚴") }}</div>
        </el-col>
        <el-col :span="2" :lg="3" :md="4" :sm="3" :xs="4" @click="jumpNavigation(3)"
          >
          <div @click="jumpNavigation(3)">{{ $t("最新法訊") }}</div>
        </el-col>
        <el-col :span="2" :lg="3" :md="4" :sm="3" :xs="4" @click="jumpNavigation(4)"
          >
          <div @click="jumpNavigation(4)">{{ $t("參觀資訊") }}</div>
        </el-col>
        <el-col :span="2" :lg="3" :md="4" :sm="3" :xs="4" @click="jumpNavigation(5)"
          >
          <div @click="jumpNavigation(5)">{{ $t("活動花絮") }}</div>
        </el-col>
      </el-row>
    </div>
    <div class="header" v-else>
         <el-row :gutter="10">
        <el-col :span="8" :xs="4">
          <div class="logo">
            <img src="@/assets/img/function/logo.png" alt="" />
          </div>
        </el-col>
        <el-col :span="1" :xs="1" :offset="16">
            <i
              style="font-size: 25px; padding: 20px"
              class="el-icon-s-unfold"
              @click="showMask = true"
              v-if="!showMask"
            ></i>
            <i
              v-if="showMask"
              style="font-size: 25px; padding: 20px"
              class="el-icon-s-fold"
              @click="showMask = false"
            ></i>
        </el-col>
        </el-row>
         <div v-if="showMask" class="mask">
          <div>
            <div @click="jumpNavigation(1)">{{ $t("寺院簡介") }}</div>
            <div @click="jumpNavigation(2)">{{ $t("妙智莊嚴") }}</div>
            <div @click="jumpNavigation(3)">{{ $t("最新法訊") }}</div>
            <div @click="jumpNavigation(4)">{{ $t("參觀資訊") }}</div>
            <div @click="jumpNavigation(5)">{{ $t("活動花絮") }}</div>
          </div>
         </div>
    </div>
  </div>
</template>

<script>
import { Settingfont } from "@/utils/translate.js";
import { deviceJudgment } from "@/utils/index.js";
export default {
  name: "WebsiteHeader",
  components: {},
  data() {
    return {
      mobile: deviceJudgment(),
      font: sessionStorage.getItem("zt") || "ft",
      showMask: false,
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    // 处理语言切换
    toggleTheFont(type) {
      Settingfont(type);
    },

    jumpNavigation(type) {
      if (this.mobile) {
       this.showMask = false;
      } 
      if (type == 4) {
       this.handleMouseEnter()
      } 
        this.$emit("jumpNavigation", type);    
    },
        // 弹窗登记
    handleMouseEnter() {
      this.$confirm(
        this.$t("善信是否需要联系寺院客服"),
        this.$t("阿弥陀佛善信吉祥"),
        {
          confirmButtonText: this.$t("确定"),
          cancelButtonText: this.$t("取消"),
        }
      )
        .then(() => {
          ssq.push("chatOpen");
          this.popUpStatus = false;
        })
        .catch(() => {
          this.$message({
            type: "warning",
            message: this.$t("可点击右下角联系寺院客服哦"),
          });
          this.popUpStatus = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  width: 80%;
  padding: 0 10%;
  height: 80px;
  line-height: 80px;
  background-color: #f5f5f583;
// background-color: #A86105;
  cursor: default;
  color: #000;
  .logo {
    width: 80%;
    text-align: center;
    img {
      vertical-align: middle;
    //   width: 100%;
    }
  }
}

   .mask {
      position: fixed;
      top: 80px;
      left: 0;
      width: 100%;
      height: calc(100% - 80px);
      background-color: #eee;
      opacity: 0.9;
      z-index: 800;
      div {
        padding: 10px;
        border-bottom: 1px solid #ccc;
        color: #8f5939;
      }
    }
</style>
